import { i18n } from "../src/plugins/i18n";

const content = {
  tabs: [
    {
      value: "ActiveAlerts",
      label: i18n.t("views.PowerdataAlerts.tabs.activeAlerts.label"),
    },
    {
      value: "ManageAlerts",
      label: i18n.t("views.PowerdataAlerts.tabs.manageAlerts.label"),
    },
  ],
  DeviceType: ["", "ROG1PHASE", "ROG3PHASE"],
  TriggerField1: [
    {
      label: "Alarm",
      value: "Alarm",
    },
    {
      label: "Max Current PH1",
      value: "Current0Max",
    },
    {
      label: "Med Current PH1",
      value: "Current0Med",
    },
    {
      label: "Max Current PH2",
      value: "Current1Max",
    },
    {
      label: "Med Current PH2",
      value: "Current1Med",
    },
    {
      label: "Max Current PH3",
      value: "Current2Max",
    },
    {
      label: "Med Current PH3",
      value: "Current2Med",
    },
    {
      label: "Max Temperature",
      value: "TemperatureMax",
    },
    {
      label: "Med Temperature",
      value: "TemperatureMed",
    },
    {
      label: "Imbalance",
      value: "Imbalance",
    },
    {
      label: "Total Power",
      value: "TotalPower",
    },
  ],
  TriggerField: [
    {
      label: "H₂ Level",
      value: "H2Lvl",
    },
    {
      label: "Liquid Temperature",
      value: "OilTemp",
    },
    {
      label: "Pressure",
      value: "Pressure",
    },
    {
      label: "Moisture",
      value: "Moisture",
    },
    {
      label: "Rate of Change",
      value: "RateOfChange",
    },
  ],
  AlertType: [
    {
      label: "Alarm",
      value: "alarm",
    },
    {
      label: "Caution",
      value: "caution",
    },
  ],
  TriggerOperator: ["<", ">", "="],
  alerts_table: [
    {
      align: "start",
      text: "Alert ID",
      value: "alert_id",
      sortable: true,
      of_type: "text",
    },
    {
      text: "XFMR ID",
      value: "asset_id",
      of_type: "link",
      identifier: "device_id",
      url: "/scavenger_h2/",
    },
    {
      text: "Alert Type",
      value: "alert_type",
      of_type: "text",
      caps: true,
    },
    {
      text: "Trigger Field",
      value: "field",
      of_type: "lookup",
      config: "ScvDeviceFields",
    },

    {
      text: "Trigger Value",
      value: "trigger_value",
      of_type: "number",
      decimal: 2,
    },
    {
      text: "Trigger Operator",
      value: "trigger_operator",
      of_type: "text",
    },
    {
      text: "",
      value: "moreActions",
      sortable: false,
      of_type: "action",
      values: ["ManageRecipients", "EditDetails", "Delete"],
      labels: ["Manage Recipients", "Edit Details", "Delete"],
    },
  ],
  active_alerts_table: [
    {
      align: "start",
      text: "Alert ID",
      value: "alert_id",
      sortable: true,
      of_type: "text",
    },
    {
      text: "XFMR ID",
      value: "asset_id",
      of_type: "link",
      identifier: "device_id",
      url: "/scavenger_h2/",
    },
    {
      text: "Alert Type",
      value: "alert_type",
      of_type: "text",
      caps: true,
    },
    {
      text: "Trigger Field",
      value: "field",
      of_type: "lookup",
      config: "ScvDeviceFields",
    },
    {
      text: "Trigger Operator",
      value: "trigger_operator",
      of_type: "text",
    },
    {
      text: "Trigger Value",
      value: "trigger_value",
      of_type: "number",
      decimal: 2,
    },
    {
      text: "Actual Value",
      value: "actual_value",
      of_type: "number",
      decimal: 2,
    },
    {
      text: "Trigger Date",
      value: "timestampISO",
      of_type: "date",
    },
  ],
  value_limits: {
    H2Lvl: {
      min: 5,
      max: 5000,
      suffix: "ppm",
    },
    OilTemp: {
      min: 0,
      max: 120,
      suffix: "°C",
    },
    PCBTemp: {
      min: 0,
      max: 120,
      suffix: "°C",
    },
    Pressure: {
      min: 0.5,
      max: 29.5,
      suffix: "bar",
    },
    Moisture: {
      min: 5,
      max: 100,
      suffix: "%",
    },
    FrequencyMean: {
      min: 40,
      max: 60,
      suffix: "Hz",
    },
  },
  alerts_type: [
    {
      label: "Alarm",
      value: "alarm",
    },
    {
      label: "Caution",
      value: "caution",
    },
  ],
  alerts_conditions: [
    {
      label: "Crosses over (>)",
      value: ">",
    },
    {
      label: "Crosses below (<)",
      value: "<",
    },
  ],
  alerts_trigger_frequency: [
    {
      label: "Only Once",
      value: true,
    },
    {
      label: "Every Time",
      value: false,
    },
  ],
};

export { content };
